import { apiClient } from './client';
export const userApi = {
    // Me endpoint - returns complete user profile with roles and workspaces
    async getMe() {
        const endpoint = `/api/Users/Me`;
        return apiClient.get(endpoint);
    }
};
